export const UPDATE_STATE = 'UPDATE_STATE';
export const UPDATE_TOGGLE = 'UPDATE_TOGGLE';
export const UPDATE_WELCOME_MESSAGE = 'UPDATE_WELCOME_MESSAGE';
export const UPDATE_CURSOR_CONTEXT_PLUGIN = 'UPDATE_CURSOR_CONTEXT_PLUGIN';

export type UPDATE_STATE_TYPE = {
    type: 'UPDATE_STATE';
    payload: AIChatbotStateDef;
};

export type UPDATE_TOGGLE_TYPE = {
    type: 'UPDATE_TOGGLE';
    payload: boolean;
};

export type UPDATE_WELCOME_MESSAGE_TYPE = {
    type: 'UPDATE_WELCOME_MESSAGE';
    payload: string;
};
export type UPDATE_CURSOR_CONTEXT_PLUGIN_TYPE = {
    type: 'UPDATE_CURSOR_CONTEXT_PLUGIN';
    payload: boolean;
};

export interface AIChatbotStateDef {
    isAllowedInSubscription: boolean;
    isAiEnabled: boolean;
    welcomeMessage: string;
    contextPlugins: AIContextPluginStateDef;
}

export interface AIContextPluginStateDef {
    isAllowedInSubscription: boolean;
    showMarketingContent: boolean;
    cursorIntegration: { isEnabled: boolean };
}
